export { default } from './useSlotProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useSlotProps/index.js
// module id = 77
// module chunks = 22